import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import React from 'react';

const spinWrapper: React.CSSProperties = {
  textAlign: 'center',
  background: 'rgba(255, 255, 255, 0.55)',
  position: 'absolute',
  zIndex: 2,
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};

const LoadingIcon = <LoadingOutlined style={{ fontSize: 48 }} spin />;

export const Loading: React.FC<{ loading: boolean }> = (props) => {
  if (props && props.loading) {
    return (
      <div style={spinWrapper}>
        <Spin size='large' indicator={LoadingIcon} spinning={props.loading} />
      </div>
    );
  } else {
    return null;
  }
};
